export const productModifierSetup = (prod) => {
  return new Promise(async (resolve, reject) => {
    let single = JSON.parse(JSON.stringify(prod))
    single.taxes = single.taxes
    single.modifier_set = single.modifier_set
    // single.modifier_set.server_id = single.modifier_set.id
    if (single.modifier_set.length > 0) {
      single.modifier_set.map((set) => {
        set.server_id = set.id
        set.modifiers = set.modifiers
        if(set.modifiers.length > 0) {
          set.modifiers.map((mod) => {
            mod.server_id = mod.id
          })
        }
        set.selected_modifiers = []
        set.total_modifiers_price = 0
        set.modifiers.sort(function(a, b) {
          return a.sort - b.sort
        })
      })
      single.total_modifiers_price = 0
      single.is_modifier_product = 1
    } else {
      single.modifier_set = []
      single.total_modifiers_price = 0
      single.is_modifier_product = 0
    }
    resolve(single)
  })
}

export const productTaxCalculation = (taxes, quantity, total) => {
  let taxesData = []
  let total_tax_collected = 0
  let total_fee_collected = 0
  if (taxes != undefined && taxes.length > 0) {
    taxes.map((tax) => {
      let tax_collected = 0
      let fee_collected = 0
      if (tax.type == 'per') {
        if (isValidSetting(tax.is_fee) && tax?.is_fee) {
          fee_collected = parseFloat(twofix((total * tax.percentage) / 100))
        } else {
          tax_collected = parseFloat(twofix((total * tax.percentage) / 100))
        }
      } else if(parseFloat(total) > 0) {
        if (isValidSetting(tax.is_fee) && tax?.is_fee) {
          fee_collected = parseFloat(twofix(quantity * tax.percentage))
        } else {
          tax_collected = parseFloat(twofix(quantity * tax.percentage))
        }
      }
      total_tax_collected = parseFloat(total_tax_collected) + parseFloat(tax_collected)
      tax.item_tax_collection = tax_collected
      total_fee_collected = parseFloat(total_fee_collected) + parseFloat(fee_collected)
      tax.item_fee_collection = fee_collected
      if (undefined != tax.tax_server_id && null != tax.tax_server_id && '' != tax.tax_server_id) {
        tax.id = tax.tax_server_id
        delete tax.tax_server_id
      }
      taxesData.push(tax)
    })
  }
  let obj = {
    taxes: taxesData,
    total_tax_collected: twofix(total_tax_collected),
    total_fee_collected: twofix(total_fee_collected)
  }
  return obj
}

const isValidSetting = (setting) => {
  return setting != undefined && setting != null && setting != ''
}

const twofix = (value) => {
  return parseFloat(value).toFixed(2)
}